/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
import type { TradingValueItemTypeMeta } from "./item"
export let BaseTradeValue = contentCatalog.items.trade as Partial<Record<string, TradingValueItemTypeMeta>>

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    BaseTradeValue: catalog.items.trade as Partial<Record<string, TradingValueItemTypeMeta>>,
}), next => {
    BaseTradeValue = next.BaseTradeValue
})
